import Vue from 'vue'
import Vuex from 'vuex'

import User from './modules/user'
import Breadcrumb from './modules/breadcrumb'
import Loading from './modules/loading'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        User,
        Breadcrumb,
        Loading
    }
})

export default store
